




































































































































import { Component, Vue } from 'vue-property-decorator';
import CommonButton from '@/components/common/CommonButton.vue';
import { SignUpParam } from '@/@types/Auth';
import { Auth } from 'aws-amplify';

@Component({
  components: {
    CommonButton,
  },
})
export default class CreateAccountBase extends Vue {
  private textFieldColor: string = '#3c3c3c';
  private accountName = '';
  private mailAddress = '';
  private password = '';
  private passwordConfirmation = '';
  private showPassword = false;
  private showPasswordConfirmation = false;
  private message = '';

  private isShowLeft() {
    if (this.$vuetify.breakpoint.width < 1200) {
      return false;
    }
    return true;
  }

  private col() {
    if (this.$vuetify.breakpoint.width < 1200) {
      return '12';
    }
    return '8';
  }

  private setMessage(message: string): void {
    this.message = message;
  }

  private async confirm() {
    if (!this.validateSignUpParam()) {
      return;
    }
    const isSendCode = confirm(
      '入力されたメールアドレスに確認コードを送信します。よろしいですか？'
    );
    if (!isSendCode) {
      return;
    }
    await this.onSignUp();
  }

  private async onSignUp() {
    try {
      const signUpParam: SignUpParam = {
        username: this.accountName,
        password: this.password,
        attributes: {
          email: this.mailAddress,
        },
      };
      await Auth.signUp(signUpParam);
      this.$router.push({ name: 'confirmSignUp' });
      return;
    } catch (error) {
      if (error.code) {
        switch (error.code) {
          case 'UsernameExistsException':
            this.setMessage('既に同じアカウント名が存在します。');
            break;
          case 'InvalidPasswordException':
            this.setMessage('このパスワードは使用できません。');
            break;
          case 'InvalidParameterException':
            this.setMessage('入力項目に有効でない値が含まれています。');
            break;
          default:
            this.setMessage('予期しないエラーが発生しました。');
            break;
        }
      } else {
        this.setMessage('予期しないエラーが発生しました。');
      }
    }
  }

  private validateSignUpParam() {
    if (
      this.accountName === '' ||
      this.mailAddress === '' ||
      this.password === '' ||
      this.passwordConfirmation === ''
    ) {
      this.setMessage(
        'アカウント名、メールアドレス、パスワード、パスワード（確認）は必須です。'
      );
      return false;
    } else if (this.password !== this.passwordConfirmation) {
      this.setMessage('パスワードとパスワード（確認用）が異なっています。');
      return false;
    } else {
      this.setMessage('');
      return true;
    }
  }
}
